import React, { SyntheticEvent, useEffect, useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { FormContainer } from '../components/FormContainer'
import UsersOptions from '../components/UsersOptions'
import IssueService from '../util/issues.service'
import TokenService from '../util/token.service'
import UserService from '../util/users.service'

const EditIssueScreen = () => {
  const [title, setTitle] = useState('')
  const [version, setVersion] = useState('')
  const [description, setDescription] = useState('')
  const [issueDeveloperId, setIssueDeveloperId] = useState('')
  const [priority, setPriority] = useState('')
  const [isCreator, setIsCreator] = useState(false)
  const [optionUsers, setOptionUsers] = useState([])
  const [status, setStatus] = useState('')
  const [allowedStatus, setAllowedStatus] = useState([])
  const [target, setTarget] = useState('')
  const location:any = useLocation()

  useEffect(() => {
    const allowedStatusDeveloper:any = ['Não será Removido', 'Duplicado', 'Não é erro', 'Resolvido']
    const allowedStatusScrumQA:any = ['Aprovado', 'Reprovado']
    setTarget(`issues/${location.state.id}`)
    setTitle(location.state.title)
    setVersion(location.state.version)
    setDescription(location.state.description)
    setIssueDeveloperId(location.state.issueDeveloperId)
    setPriority(location.state.priority)
    const { role, id } = TokenService.getUser()
    if (role === 'Developer') {
      setAllowedStatus(allowedStatusDeveloper)
    } else {
      setAllowedStatus(allowedStatusScrumQA)
    }

    const f = async () => {
      const { users } = await UserService.getUsersByRole('Developer')
      setOptionUsers(users)
    }
    f()

    if (id === location.state.issueCreatorId) { setIsCreator(true) }
  }, [])

  const submitHandler = async (e: SyntheticEvent) => {
    e.preventDefault()

    await IssueService.updateIssue(title, version, description, issueDeveloperId, priority, status, target)

    location.href = '/'
  }
  return (
    <FormContainer>
        <h1>Cadastro de Problemas</h1>
        <Form onSubmit={submitHandler}>
            <Form.Group className='my-3' controlId='title'>
                <Form.Label>Título</Form.Label>
                <Form.Control type='text' placeholder='Digite o título do problema'
                value={title}
                onChange={e => setTitle(e.target.value)}
                disabled={!isCreator}
                />
            </Form.Group>
            <Form.Group className='my-3' controlId='version'>
                <Form.Label>Versão</Form.Label>
                <Form.Control type='text' placeholder='Digite a versão'
                value={version}
                onChange={e => setVersion(e.target.value)}
                disabled={!isCreator}
                />
            </Form.Group>
            <Form.Group className='my-3' controlId='description'>
                <Form.Label>Descrição</Form.Label>
                <Form.Control type='text' placeholder='Digite a descrição do problema'
                value={description}
                onChange={e => setDescription(e.target.value)}
                disabled={!isCreator}
                />
            </Form.Group>
            <Form.Group className='my-3'>
                <Form.Label>Atribuição</Form.Label>
                    <Form.Select
                    value={issueDeveloperId}
                    onChange={e => setIssueDeveloperId(e.target.value)}
                    disabled={!isCreator}
                    >
                    <UsersOptions items={optionUsers}/>
                    </Form.Select>
            </Form.Group>
            <Form.Group className='my-3' controlId='priority'>
                <Form.Label>Prioridade</Form.Label>
                    <Form.Select
                    value={priority}
                    onChange={e => setPriority(e.target.value)}
                    disabled={!isCreator}
                    >
                    <option value ='' disabled>Escolha a prioridade do problema</option>
                    <option value='Baixa'>Baixa</option>
                    <option value='Normal'>Normal</option>
                    <option value='Alta'>Alta</option>

                    </Form.Select>
            </Form.Group>
            <Form.Group className='my-3' controlId='status'>
                <Form.Label>Status</Form.Label>
                    <Form.Select
                    value={status}
                    onChange={e => setStatus(e.target.value)}
                    >
                    {allowedStatus.map((filteredStatus, i) => { return <option key={i} value={filteredStatus}>{filteredStatus}</option> })}

                    </Form.Select>
            </Form.Group>
            <Button variant='primary' type='submit' className='my-3'>
                Enviar
            </Button>
        </Form>
    </FormContainer>
  )
}

export default EditIssueScreen
